var _a;
import MetaData from "components/metadata/MetaData";
import { defaultPermissions } from "components/metadata/utils";
class EmailTemplate extends MetaData {
    attachmentSettingsId;
    content;
    contentSettingsId;
    name;
    subject;
    constructor(response) {
        super(response);
        this.attachmentSettingsId = response?.attachmentSettingsId;
        this.content = response?.content ?? '';
        this.contentSettingsId = response?.contentSettingsId;
        this.subject = response?.subject ?? '';
        this.name = response?.name;
    }
    #clone() {
        return new _a({
            createdBy: this.createdBy,
            createdDate: this.createdDate,
            id: this.id,
            lastModifiedBy: this.lastModifiedBy,
            lastModifiedDate: this.lastModifiedDate,
            permissions: this.permissions,
            attachmentSettingsId: this.attachmentSettingsId,
            content: this.content,
            contentSettingsId: this.contentSettingsId,
            name: this.name,
            subject: this.subject,
        });
    }
    setContent(content) {
        const clone = this.#clone();
        clone.content = content;
        return clone;
    }
    setSubject(subject) {
        const clone = this.#clone();
        clone.subject = subject;
        return clone;
    }
    setName(name) {
        const clone = this.#clone();
        clone.name = name;
        return clone;
    }
    setPermissions(permissions) {
        const clone = this.#clone();
        clone.permissions = permissions;
        return clone;
    }
    setAttachmentSettingsId(attachmentSettingsId) {
        const clone = this.#clone();
        clone.attachmentSettingsId = attachmentSettingsId;
        return clone;
    }
    setContentSettingsId(contentSettingsId) {
        const clone = this.#clone();
        clone.contentSettingsId = contentSettingsId;
        return clone;
    }
    equals(other) {
        return this.attachmentSettingsId === other.attachmentSettingsId && this.content === other.content && this.contentSettingsId === other.contentSettingsId &&
            MetaData.equals(this, other) && this.name === other.name && this.subject === other.subject;
    }
    removeMeta() {
        const clone = this.#clone();
        delete clone.id;
        delete clone.createdBy;
        delete clone.createdDate;
        delete clone.lastModifiedBy;
        delete clone.lastModifiedDate;
        clone.permissions = defaultPermissions;
        return clone;
    }
}
_a = EmailTemplate;
export default EmailTemplate;
